<template>
  <div>
    <CCol sm="12" class="pl-0 pr-0">
      <CRow>
        <div class="col-sm-6 col-md-3">
          <label for>Select Status</label>
          <select
            @change="filterChange(formData.status)"
            v-model="formData.status"
            name
            id
            class="form-control"
          >
            <option value>All</option>
            <option value="active">Active</option>
            <option value="upcoming">Upcoming</option>
            <option value="expired">Expired</option>
          </select>
        </div>
        <div class="col-sm-6 col-md-3">
          <label for>Date Filter</label>
          <div class="datepicker pos-r">
            <datepicker
              v-model="dateForFilter"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD/MM/YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'Select Date Range'
                  "
                  v-on="inputEvents.start"
                  class="form-control pos-r"
                  placeholder="Select Date Range"
                />
                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg subscription-cross-svg"
                  @click="resetJoiningDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg pos-a">
              <calendarSVG />
            </div>
          </div>
        </div>
        <div
          v-if="permissions.includes('CAN_EXPORT_CSV_CENTER')"
          class="col-md-3 col-sm-6"
        >
          <label class="col-sm-12 mb-0 d-none-mob1" for></label>
          <v-btn
            :loading="csvLoader"
            :disabled="isEmpty"
            @click="downloadCsv()"
            class="btn btn-primary mt-0"
            >Export</v-btn
          >
        </div>
      </CRow>
    </CCol>
    <div class="subs-table ov-both">
      <table class="table userlistTable subscriptlistTable sub-width">
        <thead>
          <tr class="table-success">
            <!-- 1 -->
            <th scope="col" class="min-width-50">Sr No.</th>
            <!-- 2 -->
            <th scope="col" class="min-width-120">User name</th>
            <!-- 3 -->
            <th v-if="role != 'doctor' && role != 'allied'" scope="col" class="min-width-120">
              Centre Name
            </th>
            <!-- 4 -->
            <!-- <th v-if="role != 'doctor'" scope="col" class="min-width-120">
                No.of Subscribed centres
              </th>-->
            <!--  5-->
            <th scope="col">Status</th>
            <!--  6-->
            <th scope="col">Date of Purchase</th>
            <!--  7-->
            <th scope="col">Date of Expiry</th>
            <!-- 8 -->
            <th scope="col" class="min-width-130">Contact Number</th>
            <!-- 9 -->
            <th scope="col">Plan</th>
            <!-- 10 -->
            <th scope="col">Validity</th>
            <!-- 11 -->
            <!-- <th scope="col">Action</th> -->
          </tr>
        </thead>

        <tbody>
          <tr>
            <!-- 1. Filter Sr No-->
            <td></td>
            <!-- 2. Filter User name-->
            <td>
              <input
                placeholder="Search"
                v-model="formData.user_name"
                @input="debounceSearch()"
                class="form-control"
              />
            </td>
            <!-- 3. Filter centre name -->
            <td v-if="role != 'doctor' && role != 'allied'">
              <input
                v-if="role != 'doctor' && role != 'allied'"
                placeholder="Search"
                v-model="formData.center_name"
                @input="debounceSearch()"
                class="form-control"
              />
            </td>
            <!-- 5. Filter status -->
            <td>
              <div class="position-relative table-select">
                <select
                  @change="filterChange(formData.status)"
                  v-model="formData.status"
                  name
                  id
                  class="form-control"
                >
                  <option value>All</option>
                  <option value="active">Active</option>
                  <option value="upcoming">Upcoming</option>
                  <option value="expired">Expired</option>
                  <option value="near_expiry">Near Expiry</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </td>
            <!-- 6. Date of Purchase -->
            <td></td>
            <!-- 7. Date of expiry -->
            <td></td>
            <!-- 8. Filter Contact Number -->
            <td>
              <input
                @input="debounceSearch()"
                v-model="formData.mobile"
                placeholder="Number"
                class="form-control"
              />
            </td>
            <!-- 9.	Filter plan -->
            <td>
              <div class="position-relative table-select">
                <select
                  @change="filterChange(formData.plan)"
                  v-model="formData.plan"
                  name
                  id
                  class="form-control"
                >
                  <option value>All</option>
                  <option
                    v-for="(option, i) in planList"
                    :key="i"
                    :value="option.settings.plan_name"
                  >
                    {{ option.settings.plan_name }}
                  </option>
                  <option value="ext_free">Extended Free Trial</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </td>
            <!-- 10.	Filter validity -->
            <td>
              <div
                v-if="formData.plan === 'Advance' || formData.plan === 'Basic'"
                class="position-relative table-select"
              >
                <select
                  @change="filterChange(formData.validity)"
                  v-model="formData.validity"
                  name
                  id
                  class="form-control"
                >
                  <option value="All">All</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Half Yearly">Half yearly</option>
                  <option value="Yearly">Yearly</option>
                </select>
                <span class="drop-icon">
                  <i
                    aria-hidden="true"
                    class="
                      v-icon
                      mdi mdi-menu-down
                      theme--light
                      position-absolute
                    "
                  ></i>
                </span>
              </div>
            </td>
          </tr>

          <tr
            v-show="!showLoader"
            v-for="(item, i) in subscriptionList"
            :key="i"
          >
            <!-- 1. Sr No-->
            <td>{{ item.sr_no }}</td>
            <!-- 2. User name-->
            <td>
              <div>{{ item.user.full_name }}</div>
            </td>
            <!-- 3. center name -->
            <td v-if="role != 'doctor' && role != 'allied'">
              <div class="center-name">
                {{ item.center_name }}
              </div>
            </td>
            <!-- 5. status -->
            <td>
              <div>{{ item.status }}</div>
            </td>
            <!-- 6. Date of Purchase -->
            <td>
              <div>
                {{
                  item.date_of_purchase
                    ? dayJS(item.date_of_purchase).format(formats.date_format)
                    : "&#8213;"
                }}
              </div>
            </td>
            <!-- 7. Date of Expiry   -->
            <td>
              <div>
                {{
                  item.expiration_date
                    ? dayJS(item.expiration_date).format(formats.date_format)
                    : "&#8213;"
                }}
              </div>
            </td>
            <!-- 8. Contact Number -->
            <td>
              <div>{{ item.user.mobile }}</div>
            </td>
            <!-- 9. plan -->
            <td>
              <div>{{ item.name }}</div>
            </td>
            <!-- 10. validity -->
            <td>
              <div>{{ item.validity_text }}</div>
            </td>
          </tr>

          <tr v-if="showLoader">
            <td colspan="10">
              <v-skeleton-loader
                v-if="showLoader"
                v-bind="attrs"
                type="list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar, divider,list-item-avatar,
                  divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar,divider,list-item-avatar"
              ></v-skeleton-loader>
            </td>
          </tr>

          <tr v-if="isEmpty">
            <td colspan="10">
              <div v-if="isEmpty">
                <h2 class="text-center">No Data Found</h2>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <pagination
      v-if="!isEmpty"
      class="mx-6"
      :currentPage="formData.page"
      :recordPerPage="formData.records_per_page"
      :total="total"
      @changePage="changePage"
    />
    <CCol> </CCol>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import config from "@/config.js";
import debounce from "lodash/debounce";
import { pickSvg } from "@/views/SVG";
import Datepicker from "v-calendar/lib/components/date-picker.umd";

const pagination = () => import("@/views/common/Pagination");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
import formats from "@/formats";
export default {
  props: ["role", "joinOnDateRange"],
  components: {
    pagination,
    Datepicker,
    ...pickSvg("calendarSVG"),
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },
  data() {
    return {
      dateForFilter: this.joinOnDateRange,
      attrs: {
        class: "mb-6",
        boilerplate: true,
        elevation: 2,
      },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      csvLoader: false,
      dayJS,
      formats,
      subscriptionList: [],
      total: 0,
      isEmpty: false,
      showLoader: false,
      planList: [],
      formData: {
        role: this.role,
        page: 1,
        records_per_page: 10,
        user_name: "",
        mobile: "",
        location: "",
        status: "",
        plan: "",
        center_name: "",
        validity: "",
      },
    };
  },
  mounted() {
    this.getSubscriptionReportsList();
  },
  methods: {
    downloadCsv() {
      this.csvLoader = true;
      let params = {
        ...this.formData,
      };
      if (this.dateForFilter.start !== "") {
        (params.start_date = this.dateForFilter.start.toISOString()),
          (params.end_date = this.dateForFilter.end.toISOString());
      }
      let url = `${config.SUBSCRIPTIONS_URL}api/v2/admin/subscription/reports/csv`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          this.csvLoader = false;
          const data = response.data.data;
          this.download(data.fileName, data.csv);
        }
      });
    },
    download(filename, text) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    resetJoiningDate() {
      this.dateForFilter = { start: "", end: "" };
      this.getSubscriptionReportsList();
      this.$emit("removeDate");
    },
    dateChange() {
      this.getSubscriptionReportsList();
    },
    getSubscriptionReportsList() {
      this.showLoader = true;
      let params = {
        ...this.formData,
      };
      if (this.dateForFilter.start !== "") {
        (params.start_date = this.dateForFilter.start.toISOString()),
          (params.end_date = this.dateForFilter.end.toISOString());
      }
      let url = `${config.SUBSCRIPTIONS_URL}api/v1/admin/subscriptions/reports`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data.list.length) {
            this.getPlan();
            this.isEmpty = false;
            this.showLoader = false;
            this.subscriptionList = response.body.data.list;
            this.total = response.body.data.count;
            this.subscriptionList.map((el, index) => {
              return (el.sr_no =
                this.formData.records_per_page * this.formData.page -
                this.formData.records_per_page +
                1 +
                index);
            });
          } else {
            this.isEmpty = true;
            this.showLoader = false;
            this.subscriptionList = [];
          }
        } else {
          // API returned status: false (error response)
          this.isEmpty = true;
          this.showLoader = false;
          this.subscriptionList = [];
        }
      }).catch(() => {
        // Network error or server error — stop the loader
        this.isEmpty = true;
        this.showLoader = false;
        this.subscriptionList = [];
      });
    },

    // get plan logic
    getPlan() {
      this.showLoader = true;
      let params = {
        role: this.role,
      };
      let url = `${config.BASE_URL}api/v2/admin/subscriptions`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data) {
            this.showLoader = false;
            this.planList = response.body.data;
          } else {
            this.showLoader = false;
            this.planList = [];
          }
        }
      });
    },

    // change page
    changePage(page) {
      this.formData.page = page.currentPage;
      this.getSubscriptionReportsList();
    },

    debounceSearch: debounce(function () {
      this.getSubscriptionReportsList();
    }, 500),

    // all filter change
    filterChange(data) {
      this.getSubscriptionReportsList();
    },
  },
};
</script>